export const selectGoodsList = state => state.selectGoodsList // 获取存储的选中商品信息

export const selectSaveStoreInfo = state => state.selectStoreInfo // 获取存储的门店信息

export const judgeStatus = state => state.judgeStatus // 判断是否从

export const groupActivityContent = state => state.groupActivityContent // 活动文本内容

export const groupBuyActivity = state => state.groupBuyActivity // 获取活动内容

export const groupBuyActivityStoreInfo = state => state.groupBuyActivityStoreInfo // 获取选中的门店

export const groupBuyActivityState = state => state.groupBuyActivityState // 活动列表tab状态

export const groupBuyDetailActivityState = state => state.groupBuyDetailActivityState // 活动详情状态

export const isBackGeneralCode = state => state.isBackGeneralCode // 订单页是否从扫码点单核销页返回的
